import { render, staticRenderFns } from "./MyPictureDetail.vue?vue&type=template&id=2907c5cb&scoped=true"
import script from "./MyPictureDetail.vue?vue&type=script&lang=js"
export * from "./MyPictureDetail.vue?vue&type=script&lang=js"
import style0 from "./MyPictureDetail.vue?vue&type=style&index=0&id=2907c5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2907c5cb",
  null
  
)

export default component.exports